/**
 * Configurações específicas para o cliente "Happy Consig"
 */
const settings: ClientSettings = {
  name: "ZiliCred",
  benefitCardName: "Cartão",
  theme: {
    token: {
      colorPrimary: "#2D2A26",
      colorHighlight: "#FFC629",
    },
  },
  assets: {
    background: "/background.jpg",
    logo: "/logo.png",
    favicon: "/favicon.png",
    card: "/card.png",
    consignedCard: "/consigned-card.png",
  },
  cardExclusiveTheme: {
    name: "Amigoz",
    theme: {
      token: {
        colorPrimary: "#2D2A26",
        colorHighlight: "#FFC629",
      },
    },
    assets: {
      background: "/background-card-exclusive.png",
      logo: "/logo-card-exclusive.png",
      favicon: "/favicon-card-exclusive.png",
    },
  },
};

export default settings;
